import { render, staticRenderFns } from "./PointOfSale.vue?vue&type=template&id=46304d4a&"
import script from "./PointOfSale.vue?vue&type=script&lang=ts&"
export * from "./PointOfSale.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports